import React from "react";

function DataCollectionIcon({ height = "80", width = "80", className = "" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.447 6.27193H19.2101L15.5259 9.95614L11.8417 6.27193H14.6049V1.66666H16.447V6.27193ZM2.58963 17.3721H15.1936V11.9883H16.9941V17.3721C16.9941 18.3591 16.1839 19.1667 15.1936 19.1667H2.58963C1.59932 19.1667 0.789062 18.3591 0.789062 17.3721V4.80984C0.789062 3.82281 1.59932 3.01524 2.58963 3.01524H9.83343V4.80984H2.58963V17.3721ZM11.5925 15.5775V11.9883H13.393V15.5775H11.5925ZM9.79189 15.5775H7.99132V8.39905H9.79189V15.5775ZM6.19076 10.1937V15.5775H4.39019V10.1937H6.19076Z"
        fill="#000"
        className={className}
      />
    </svg>
  );
}

export default DataCollectionIcon;
